var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('update-card',{attrs:{"tabs":_vm.tabs,"id":_vm.id,"storeNamespace":"pricepackages","objectNamespace":"O_pricepackage"},on:{"visitedTabs":_vm.visitedTabs}})}
var staticRenderFns = []

export { render, staticRenderFns }